import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _article = {
    publishedTime: 'google.protobuf.Timestamp',
    modifiedTime: 'google.protobuf.Timestamp',
    expirationTime: 'google.protobuf.Timestamp',
};
var _comment = {
    createdAt: 'google.protobuf.Timestamp',
    updatedAt: 'google.protobuf.Timestamp',
    reactions: '_reactions',
    replies: '_replies',
};
var _comments = { comments: '_comment' };
var _contentPreview = { openGraph: '_openGraph' };
var _createCommentRequest = {};
var _createFeedItemRequest = {};
var _createTopicRequest = { image: '_image' };
var _createTopicResponse = {};
var _deleteFeedItemRequest = {};
var _deleteTopicRequest = {};
var _empty = {};
var _feedItem = {
    createdAt: 'google.protobuf.Timestamp',
    updatedAt: 'google.protobuf.Timestamp',
    comments: '_comments',
    latestComments: '_comments',
    reactions: '_itemReactionsSummary',
    pin: '_feedItemPin',
    contentPreviews: '_contentPreview',
    requesterContext: '_feedItemRequester',
};
var _feedItemPin = { since: 'google.protobuf.Timestamp' };
var _feedItemRequester = {};
var _getFeedItemRequest = {};
var _getFeedItemTopicsStatsRequest = {};
var _getFeedItemTopicsStatsResponse = {};
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _itemReactionsSummary = {
    usersReactions: '_usersReactions',
    reactionsSummary: '_reactionsSummary',
};
var _listFeedItemsRequest = {};
var _listFeedItemsResponse = { feedItems: '_feedItem' };
var _openGraph = { typeArticle: '_article' };
var _pinToContainerRequest = {};
var _reactions = { usersReactions: '_usersReactions' };
var _reactionsSummary = { latestReactions: '_reactionSummary' };
var _reactionSummary = { reactionTime: 'google.protobuf.Timestamp' };
var _replies = { comments: '_comment' };
var _searchRequest = {};
var _subscribeToFeedItemRequest = {};
var _unpinFromContainerRequest = {};
var _unsubscribeFromFeedItemRequest = {};
var _updateFeedItemRequest = { updateMask: 'google.protobuf.FieldMask' };
var _updateTopicRequest = { image: '_image' };
var _userReaction = { reactionTime: 'google.protobuf.Timestamp' };
var _usersReactions = { userReactions: '_userReaction' };
function resolveWixFeedFeedServiceUrl(opts) {
    var domainToMappings = {
        _api_base_domain_: [
            {
                srcPath: '/social-content',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/social-content2',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/social-content',
                destPath: '/bo',
            },
        ],
        'social._base_domain_': [
            {
                srcPath: '/api',
                destPath: '/api',
            },
        ],
        _: [
            {
                srcPath: '/social-content/api',
                destPath: '/api',
            },
        ],
        'feed.wixapps.net': [
            {
                srcPath: '/api/v1/feed',
                destPath: '/api/v1/feed',
            },
            {
                srcPath: '/api/v1/activities',
                destPath: '/api/v1/activities',
            },
        ],
        'groups.wixapps.net': [
            {
                srcPath: '/social-content/api',
                destPath: '/api',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/api',
                destPath: '/api',
            },
            {
                srcPath: '/social-content',
                destPath: '/social-content',
            },
            {
                srcPath: '/social-content/api',
                destPath: '/api',
            },
        ],
        'comments.wixapps.net': [
            {
                srcPath: '/seo',
                destPath: '/seo',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/social-content/api',
                destPath: '/api',
            },
            {
                srcPath: '/social-content/api/v1',
                destPath: '/api/v1',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/social-content/api',
                destPath: '/api',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/social-content/api',
                destPath: '/api',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/social-content/api',
                destPath: '/api',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** get feed items */
export function list(payload) {
    return function __list(_a) {
        var host = _a.host;
        var toJSON = serializer(_listFeedItemsRequest, {}).toJSON;
        var fromJSON = serializer(_listFeedItemsResponse, {
            _article: _article,
            _comment: _comment,
            _comments: _comments,
            _contentPreview: _contentPreview,
            _feedItem: _feedItem,
            _feedItemPin: _feedItemPin,
            _feedItemRequester: _feedItemRequester,
            _itemReactionsSummary: _itemReactionsSummary,
            _openGraph: _openGraph,
            _reactionSummary: _reactionSummary,
            _reactions: _reactions,
            _reactionsSummary: _reactionsSummary,
            _replies: _replies,
            _userReaction: _userReaction,
            _usersReactions: _usersReactions,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'GET',
            url: resolveWixFeedFeedServiceUrl({
                protoPath: '/api/v1/feed/items',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** get feed items with filter */
export function search(payload) {
    return function __search(_a) {
        var host = _a.host;
        var toJSON = serializer(_searchRequest, {}).toJSON;
        var fromJSON = serializer(_listFeedItemsResponse, {
            _article: _article,
            _comment: _comment,
            _comments: _comments,
            _contentPreview: _contentPreview,
            _feedItem: _feedItem,
            _feedItemPin: _feedItemPin,
            _feedItemRequester: _feedItemRequester,
            _itemReactionsSummary: _itemReactionsSummary,
            _openGraph: _openGraph,
            _reactionSummary: _reactionSummary,
            _reactions: _reactions,
            _reactionsSummary: _reactionsSummary,
            _replies: _replies,
            _userReaction: _userReaction,
            _usersReactions: _usersReactions,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveWixFeedFeedServiceUrl({
                protoPath: '/api/v1/feed/items/search',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** get a single feed item */
export function get(payload) {
    return function __get(_a) {
        var host = _a.host;
        var toJSON = serializer(_getFeedItemRequest, {}).toJSON;
        var fromJSON = serializer(_feedItem, {
            _article: _article,
            _comment: _comment,
            _comments: _comments,
            _contentPreview: _contentPreview,
            _feedItemPin: _feedItemPin,
            _feedItemRequester: _feedItemRequester,
            _itemReactionsSummary: _itemReactionsSummary,
            _openGraph: _openGraph,
            _reactionSummary: _reactionSummary,
            _reactions: _reactions,
            _reactionsSummary: _reactionsSummary,
            _replies: _replies,
            _userReaction: _userReaction,
            _usersReactions: _usersReactions,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'GET',
            url: resolveWixFeedFeedServiceUrl({
                protoPath: '/api/v1/feed/items/{feedItemId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** create a feed item */
export function create(payload) {
    return function __create(_a) {
        var host = _a.host;
        var toJSON = serializer(_createFeedItemRequest, {}).toJSON;
        var fromJSON = serializer(_feedItem, {
            _article: _article,
            _comment: _comment,
            _comments: _comments,
            _contentPreview: _contentPreview,
            _feedItemPin: _feedItemPin,
            _feedItemRequester: _feedItemRequester,
            _itemReactionsSummary: _itemReactionsSummary,
            _openGraph: _openGraph,
            _reactionSummary: _reactionSummary,
            _reactions: _reactions,
            _reactionsSummary: _reactionsSummary,
            _replies: _replies,
            _userReaction: _userReaction,
            _usersReactions: _usersReactions,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveWixFeedFeedServiceUrl({
                protoPath: '/api/v1/feed/items',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** create a feed item */
export function createComment(payload) {
    return function __createComment(_a) {
        var host = _a.host;
        var toJSON = serializer(_createCommentRequest, {}).toJSON;
        var fromJSON = serializer(_comment, {
            _comment: _comment,
            _reactions: _reactions,
            _replies: _replies,
            _userReaction: _userReaction,
            _usersReactions: _usersReactions,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveWixFeedFeedServiceUrl({
                protoPath: '/api/v1/feed/items/{feedItemId}/comment',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** update the feed item */
export function update(payload) {
    return function __update(_a) {
        var host = _a.host;
        var toJSON = serializer(_updateFeedItemRequest, {}).toJSON;
        var fromJSON = serializer(_feedItem, {
            _article: _article,
            _comment: _comment,
            _comments: _comments,
            _contentPreview: _contentPreview,
            _feedItemPin: _feedItemPin,
            _feedItemRequester: _feedItemRequester,
            _itemReactionsSummary: _itemReactionsSummary,
            _openGraph: _openGraph,
            _reactionSummary: _reactionSummary,
            _reactions: _reactions,
            _reactionsSummary: _reactionsSummary,
            _replies: _replies,
            _userReaction: _userReaction,
            _usersReactions: _usersReactions,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'PATCH',
            url: resolveWixFeedFeedServiceUrl({
                protoPath: '/api/v1/feed/items/{feedItemId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** delete the feed item */
export function deleteFeedItem(payload) {
    return function __deleteFeedItem(_a) {
        var host = _a.host;
        var toJSON = serializer(_deleteFeedItemRequest, {}).toJSON;
        var fromJSON = serializer(_feedItem, {
            _article: _article,
            _comment: _comment,
            _comments: _comments,
            _contentPreview: _contentPreview,
            _feedItemPin: _feedItemPin,
            _feedItemRequester: _feedItemRequester,
            _itemReactionsSummary: _itemReactionsSummary,
            _openGraph: _openGraph,
            _reactionSummary: _reactionSummary,
            _reactions: _reactions,
            _reactionsSummary: _reactionsSummary,
            _replies: _replies,
            _userReaction: _userReaction,
            _usersReactions: _usersReactions,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'DELETE',
            url: resolveWixFeedFeedServiceUrl({
                protoPath: '/api/v1/feed/items/{feedItemId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** pin feed item to the container */
export function pinToContainer(payload) {
    return function __pinToContainer(_a) {
        var host = _a.host;
        var toJSON = serializer(_pinToContainerRequest, {}).toJSON;
        var fromJSON = serializer(_feedItemPin, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'PUT',
            url: resolveWixFeedFeedServiceUrl({
                protoPath: '/api/v1/feed/items/{feedItemId}/pin',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** pin feed item to the container */
export function unpinFromContainer(payload) {
    return function __unpinFromContainer(_a) {
        var host = _a.host;
        var toJSON = serializer(_unpinFromContainerRequest, {}).toJSON;
        var fromJSON = serializer(_feedItemPin, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'DELETE',
            url: resolveWixFeedFeedServiceUrl({
                protoPath: '/api/v1/feed/items/{feedItemId}/pin',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** subscribe/follow a feed item */
export function subscribeToFeedItem(payload) {
    return function __subscribeToFeedItem(_a) {
        var host = _a.host;
        var toJSON = serializer(_subscribeToFeedItemRequest, {}).toJSON;
        var fromJSON = serializer(_feedItemRequester, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'PUT',
            url: resolveWixFeedFeedServiceUrl({
                protoPath: '/api/v1/feed/items/{feedItemId}/subscribe',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** unsubscribe/unfollow feed item */
export function unsubscribeFromFeedItem(payload) {
    return function __unsubscribeFromFeedItem(_a) {
        var host = _a.host;
        var toJSON = serializer(_unsubscribeFromFeedItemRequest, {}).toJSON;
        var fromJSON = serializer(_feedItemRequester, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'DELETE',
            url: resolveWixFeedFeedServiceUrl({
                protoPath: '/api/v1/feed/items/{feedItemId}/unsubscribe',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** unsubscribe/unfollow feed item */
export function getFeedItemTopicsStats(payload) {
    return function __getFeedItemTopicsStats(_a) {
        var host = _a.host;
        var toJSON = serializer(_getFeedItemTopicsStatsRequest, {}).toJSON;
        var fromJSON = serializer(_getFeedItemTopicsStatsResponse, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'GET',
            url: resolveWixFeedFeedServiceUrl({
                protoPath: '/api/v1/feed/topics',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** create topic */
export function createTopic(payload) {
    return function __createTopic(_a) {
        var host = _a.host;
        var toJSON = serializer(_createTopicRequest, { _image: _image }).toJSON;
        var fromJSON = serializer(_createTopicResponse, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveWixFeedFeedServiceUrl({
                protoPath: '/api/v1/feed/topics',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** edit topic */
export function updateTopic(payload) {
    return function __updateTopic(_a) {
        var host = _a.host;
        var toJSON = serializer(_updateTopicRequest, { _image: _image }).toJSON;
        var fromJSON = serializer(_empty, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'PATCH',
            url: resolveWixFeedFeedServiceUrl({
                protoPath: '/api/v1/feed/topics/{topicId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** delete topic */
export function deleteTopic(payload) {
    return function __deleteTopic(_a) {
        var host = _a.host;
        var toJSON = serializer(_deleteTopicRequest, {}).toJSON;
        var fromJSON = serializer(_empty, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'DELETE',
            url: resolveWixFeedFeedServiceUrl({
                protoPath: '/api/v1/feed/topics/{topicId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
//# sourceMappingURL=http.js.map